import React, { Component } from 'react';
import App from './App';
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import reducers from "./store/reducer/index";
import { createStore, applyMiddleware } from "redux";
let superProps;
class WorkItem extends Component {
  constructor(props) {
    super(props);
    this.store = createStore(reducers, applyMiddleware(thunk));
    superProps = props;
  }
  render() {
    return (
      <Provider store={this.store}>
        <App {...superProps}/>
      </Provider>)
  };
}

export default WorkItem;
